import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { generalSettings } from '../../../../main/settings';
import { GeneralService } from '../../../@core/data/general.service';

import { LoginService } from '../../../@core/data/login.service';

@Component({
  selector: 'edm-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class='text-center full-width'>
      <span class="created-by">{{footerText}} <b><a [href]="href" *ngIf="showLink" target="_blank">Entrega Digital</a></b></span>
      <div class='float-right'>
        <small class='text-muted'>
          <strong class='version'>{{ getTranslate("versionLabel") }}:&nbsp;</strong>{{ version }}
        </small>
      </div>
    </div>
  `,
  standalone: false,
})
export class FooterComponent {
  href: string = 'https://www.entregadigital.app.br/';
  showLink: boolean = true;
  footerText: string;

  version: string = "2";
  pathBaseTranslate: string = 'theme.components.footer.';

  constructor(
    private generalService: GeneralService,
    private loginService: LoginService
  ) {
    this.version = this.loginService.version;
    if (generalSettings.footerHeight == 'hidden') {
      this.showLink = false;
      this.footerText = environment.appname;
      this.footerText = `${this.getTranslate("footerText")} ${this.footerText}`
      return;
    }
    if (generalSettings.footerHeight == 'none') {
      this.showLink = false;
      return;
    }
    this.footerText = `${this.getTranslate("footerText")}`;
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }
}
